<template>
    <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-reset-password">
        <div class="vx-col sm:w-full md:w-1/4 sm:m-0 m-4">
            <vx-card>
                <div slot="no-body" style="background-color:rgb(244, 244, 244)">
                    <div class="vx-row no-gutter justify-center items-center">
                        <!-- <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/login.png" alt="Intelliprice" class="mx-auto" style="width:100%">
                        </div> -->
                        <div class="vx-col sm:w-full md:w-full ml-auto mr-auto d-theme-dark-bg">
                            <div class="py-20 px-10 login-tabs-container"  v-if="initiated && validToken">
                                <img src="@/assets/images/logo/login_logo.png" alt="Intelliprice" class="align-left mb-20" style="width:220px">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Ορισμός νέου κωδικού</h4>
                                    <p>Παρακαλούμε εισάγετε το νέο κωδικό σας.</p>
                                </div>
                                <vs-input type="password" label-placeholder="Νέος κωδικός"  v-model="password1" class="w-full mb-8" />
                                <vs-input type="password" label-placeholder="Επαλήθευση κωδικού"  v-model="password2" class="w-full mb-8" />
                                <div class="error" v-if="initiatedPassword && password1 !== password2"><i>Οι δύο κωδικοί δεν είναι ίδιοι.</i></div>
                                <div class="error" v-if="initiatedPassword && password1.length < 6 "><i>Ο κωδικός θα πρέπει να έχει τουλάχιστον 6 ψηφία.</i></div>
                                <vs-button type="border" to="/recovery" class="px-4 w-full md:w-auto">Επιστροφή</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="completed" @click="setNewPassword()">Ορισμός Νέου Κωδικού</vs-button>
                                <vs-alert class="mt-5" v-if="message">{{message}}</vs-alert>
                            </div>
                            <div class="py-20 px-10 login-tabs-container"  v-if="initiated && !validToken">
                                <h4 class="mb-4">Ορισμός νέου κωδικού</h4>
                                <vs-alert class="mt-5" v-if="message">{{message}}</vs-alert>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import axios from "@/axios";

export default {
  data () {
    return {
        validToken:false,
        password1: '',
        password2: '',
        initiated:false,
        initiatedPassword:false,
        message: '',
        completed:false,
        reset_token:'',
    }
  },
    mounted(){
        let vm = this;
        vm.$vs.loading();
        vm.reset_token = vm.$route.params.reset_token;
        axios.defaults.baseURL = localStorage.getItem('apiEndpoint');
        axios.post("resetPasswordCheck", { 'reset_token': vm.reset_token})
            .then((response) => {
                if(response.data.error) {
                    vm.message = response.data.message;
                    vm.initiated = true;
                } else {
                    vm.message = response.data.message;
                    vm.initiated = true;
                    vm.validToken = true;
                }
                vm.$vs.loading.close();
            })
            .catch((error) => {
                vm.$vs.loading.close();
            })
    },
    methods: {
      setNewPassword()
      {
          let vm = this;
          vm.initiatedPassword = true;
          vm.message = '';

          if((vm.password1 !== vm.password2) || vm.password1.length < 6) {
              return;
          }

          vm.$vs.loading();
          axios.defaults.baseURL = localStorage.getItem('apiEndpoint');

          axios.post("setNewPassword", { 'password': vm.password1, reset_token: vm.reset_token })
              .then((response) => {
                  if(response.data.error) {
                      vm.message = response.data.message;
                  } else {
                      vm.message = response.data.message;
                      vm.completed = true;
                  }
                  vm.$vs.loading.close();
              })
              .catch((error) => {
                  vm.$vs.loading.close();
              })

      }
    }
}
</script>
<style>
    .error {
        color: #980b0b;
        margin-bottom:20px;
    }
</style>
